import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBoxRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowBoxRight"><Path d="M14.5 3.5L20.5 3.5V20.5H14.5M3.5 12L15 12M12 15.5L15.5 12L12 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowBoxRight;
